import { del, get, post, put } from 'services/client'
import { PAGE_LIMIT } from './constants'

const fetchSearches = () => get('procurements/searchs')

const removeSearches = ids => del('procurements/searchs', { identities: ids })

const fetchSearchDetails = ({
  id,
  page = 1,
  keyword = '',
  limit = PAGE_LIMIT,
  filters,
}) =>
  get(
    `procurements/searchs/${id}?page=${page}&limit=${limit}${
      keyword ? `&search=${keyword}` : ''
    }${
      filters && filters.hasOwnProperty('homologated')
        ? `&homologated=${filters.homologated}`
        : ''
    }${
      filters && filters.hasOwnProperty('isInMyNetwork')
        ? `&is_in_my_network=${filters.isInMyNetwork}`
        : ''
    }`,
  )

const fetchVendors = ({
  page = 1,
  keyword = '',
  limit = PAGE_LIMIT,
  filters,
  data,
}) =>
  get(
    `vendors?page=${page}&limit=${limit}${keyword ? `&search=${keyword}` : ''}${
      filters && filters.hasOwnProperty('homologated')
        ? `&homologated=${filters.homologated}`
        : ''
    }${
      filters && filters.hasOwnProperty('isInMyNetwork')
        ? `&is_in_my_network=${filters.isInMyNetwork}`
        : ''
    }${data ? `&${data}` : ''}`,
  )

const saveNewSearch = ({ name, data }) =>
  post('procurements/searchs', { name, ...data })

const editSearch = ({ id, data }) => put(`procurements/searchs/${id}`, data)

const addVendor = identification_code =>
  post('procurements/invitations', { identification_code: identification_code })

export {
  fetchSearches,
  removeSearches,
  fetchSearchDetails,
  fetchVendors,
  saveNewSearch,
  editSearch,
  addVendor,
}
